import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import { defineComponent, reactive, watch } from 'vue';
import Validator from 'validator.tool';
export var form = {
  title: {
    type: String,
    default: '登录'
  },
  username: {
    type: String
  },
  password: {
    type: String
  },
  onSubmit: {
    type: Function,
    default: e => e.preventDefault()
  },
  onReset: {
    type: Function,
    default: e => e.preventDefault()
  },
  onChange: {
    type: Function,
    default: e => e.preventDefault()
  },
  onInput: {
    type: Function,
    default: e => e.preventDefault()
  },
  onBlur: {
    type: Function,
    default: e => e.preventDefault()
  },
  onFocus: {
    type: Function,
    default: e => e.preventDefault()
  }
};
export default defineComponent({
  props: form,

  setup(props, _ref) {
    var {} = _ref;
    var {
      onSubmit,
      onInput
    } = props;
    var errmsg = reactive({
      username: '',
      password: ''
    });
    var validator = new Validator({
      initValues: {
        username: props.username,
        password: props.password
      },
      rules: {
        username: {
          validate: val => !val || typeof val === 'string' && (val.length > 15 || val.length < 5) ? '用户名长度在 6 ～15 位！' : ''
        },
        password: {
          validate: function validate(val) {
            if (val === void 0) {
              val = '';
            }

            return typeof val === 'string' && !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,10}$/.test(val) ? '必须包含大小写字母和数字的组合，长度在 6-10 之间！' : '';
          }
        }
      }
    });
    watch(() => props.username, current => {
      validator.message('username', current);
    });
    watch(() => props.password, current => {
      validator.message('password', current);
    });

    var handleSubmit = e => {
      e.preventDefault();
      var valid = validator.allValid();
      validator.showMessages();
      var values = validator.getValues();

      for (var key in validator.fields) {
        // @ts-ignore
        errmsg[key] = validator.errorMessages[key];
      }

      if (valid) {
        onSubmit && onSubmit(e, values);
      }
    };

    var handleInput = env => {
      var target = env.target;
      var value = target.type === 'checkbox' ? target.checked : target.value;
      var name = target.name;
      validator.message(name, value);
      validator.allValid();
      onInput && onInput(env);
    };

    return () => {
      var {
        onReset,
        onChange,
        onBlur,
        onFocus
      } = props;
      return _createVNode("form", _mergeProps({
        "class": "uiv-login-form",
        "onInput": evn => handleInput(evn)
      }, {
        onSubmit: handleSubmit,
        onReset,
        onChange,
        onBlur,
        onFocus
      }), [_createVNode("h2", null, [props.title]), _createVNode("div", {
        "class": "uiv-login-field"
      }, [_createVNode("label", null, [_createVNode("input", {
        "class": errmsg.username ? 'error' : '',
        "type": "text",
        "name": "username",
        "value": validator.values.username,
        "placeholder": "请输入账号"
      }, null)]), _createVNode("div", null, [validator.errorMessages.username])]), _createVNode("div", {
        "class": "uiv-login-field"
      }, [_createVNode("label", null, [_createVNode("input", {
        "class": errmsg.password ? 'error' : '',
        "type": "password",
        "name": "password",
        "value": validator.values.password,
        "placeholder": "请输入密码"
      }, null)]), _createVNode("div", null, [validator.errorMessages.password])]), _createVNode("div", {
        "class": "uiv-login-button"
      }, [_createVNode("button", {
        "type": "submit"
      }, [_createTextVNode("\u767B\u5F55")]), !!props.onReset && _createVNode("button", {
        "type": "reset"
      }, [_createTextVNode("\u91CD\u7F6E")])])]);
    };
  }

});
//# sourceMappingURL=Form.js.map